export default "__VITE_ASSET__vlB9JWM0__"